<template>
  <div class="export-main">
    <ButtonBack class="mb_m"/>

    <div class="table">
      <div class="table-header">
        <div class="table-header-name">
          ファイル名
        </div>

        <div class="table-header-description">
          概要
        </div>
      </div>

      <div
        v-for="(e, index) in exports"
        :key="index"
        class="table-cell"
        @click="download(e)"
        >
        <div class="table-cell-name">
          {{ e.name }}
        </div>

        <div class="table-cell-description">
          {{ e.description }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import iconv from 'iconv-lite'
import ButtonBack from '@/components/ButtonBack'

export default {
  components: {
    ButtonBack
  },

  created: async function () {
    await this.$store.dispatch(
      'eventExport/get',
      this.$route.params.id
    )
  },

  data () {
    return {
      exports: [
        {
          column: 'file1',
          name: '参加者が見つけたトランプ.csv',
          description: 'トランプ番号ごとの発見回数の集計',
          headerString: 'トランプ番号,発見回数',
        },

        {
          column: 'file2',
          name: '参加者が選択したトランプ.csv',
          description: 'アンサーシートで選ばれたトランプ番号ごとの合計',
          headerString: 'トランプ番号,回答者選択',
        },

        {
          column: 'file3',
          name: '参加者が選択した答え.csv',
          description: '参加者ごとの選択されたトランプ番号の発見数',
          headerString: 'ID,1,2,3,4,5,6,7,8,9,10,11,12,13',
        },

        {
          column: 'file4',
          name: '参加者が選択しなかった答え.csv',
          description: '参加者ごとの選択されなかったトランプ番号の発見数',
          headerString: 'ID,1,2,3,4,5,6,7,8,9,10,11,12,13',
        },

        {
          column: 'file5',
          name: '見つかったトランプのログ.csv',
          description: '参加者が発見したトランプの履歴',
          headerString: '時間,ID,見つけたトランプ',
        }
      ]
    }
  },

  computed: {
    eventExport: function () {
      return this.$store.state.eventExport.eventExport
    }
  },

  methods: {
    fileUrl: function (e) {
      // TODO 苦肉の策 → どうにかしたい
      let url = this.eventExport.get(e.column).url()
      if (url && process.env.NODE_ENV === 'production') {
        url = url.replace(/^http:/, 'https:')
      }
      return url
    },

    download: function (exprt) {
      let url = this.fileUrl(exprt)

      axios.get(url).then((res) => {
        // 行毎に保持
        let lines = res.data.split(/\n/)

        // CSVヘッダ書き換え
        lines[0] = exprt.headerString
        let data = lines.join('\n')
        // Windows用にエンコード
        data = iconv.encode(data, 'windows-31j');

        // ファイル出力
        let blob = new Blob([data], {'type': 'text/csv'})
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = exprt.name
        link.click()
      })
    },
  }
}
</script>

<style lang="scss" scoped>
@mixin cell {
  &-name {
    padding: 5px;
    width: 40%;
  }

  &-description {
    padding: 5px;
    width: 60%;
  }
}

@import '@/styles/_table.scss';
</style>
